import React, { Component } from "react";
import "antd/dist/antd.css";
import {
    Form,
    Select,
    Button,
    ConfigProvider,
    Row,
    Col,
    Input,
    Space,
    Modal
} from "antd";
import { Spinner } from "reactstrap";
import axios from '../../utils/request';
import moment from "moment";
import "moment/locale/zh-cn";

import { closeModel } from "../../utils";
import "./index.css";

moment.locale("zh-cn");

export class XinWangDaBackground extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tenantId: "",
            isReady: false,
            isLoading: true,
            errorMessage: "",
            applyId: "",
            idCardNum: "",
            reportId: 0,
            idType: 1,
            contractCompany: "",
            companyOne: "",
            companyTwo: "",
            companyThree: "",
            companyFour: "",
            companyFive: "",
            btnEnable: true,

            modalOpenStatus: false,
            confirmLoading: false,
            modalText: "",

            backgroundPackages: [],
            contractCompanyValidDic: [
                { key: 1, valid: false },
                { key: 2, valid: false },
                { key: 3, valid: false },
                { key: 4, valid: false },
                { key: 5, valid: false },
            ],
            idTypes: [
                { display: "中国籍", value: 1 },
                { display: "海外", value: 0 },
            ],
            contractCompanys: [],
        };
    }
    formRef = React.createRef();

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        let tenantId = urlParams.get("tenantId");
        if (!commonParamater) {
            this.setState({
                errorMessage: "commonParamater不存在！",
                isLoading: false,
                isReady: true,
            });
            return;
        }
        if (tenantId == "431694") {
            this.setState({
                idTypes: [
                    { display: "身份证", value: 1 },
                    { display: "其他", value: 0 }
                ]
            });
        }
        this.loadPage(commonParamater);
    }

    loadPage = (commonParamater) => {
        const params = {
            commonParamater,
        };
        axios
            .get("/api/XinWangDaBackground/GetBackgroundIniData", { params: params })
            .then((res) => {
                const isSuccessValue = res.data.code == "200";
                let resdata = res.data.data;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = "初始化失败，" + res.data.message;
                } else {
                    if (resdata !== "") {
                        errorMessage = "";
                        let applyId = resdata.applyId;
                        let idCardNum = resdata.idCardNum;
                        let backgroundPackages = resdata.backgroundPackages;
                        let contractCompanys = resdata.contractCompanys;

                        this.setState({
                            applyId: applyId,
                            idCardNum: idCardNum,
                            backgroundPackages: backgroundPackages,
                            contractCompanys: contractCompanys,
                        });
                    } else {
                        errorMessage = "初始化失败！";
                    }
                }
                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch((reason) => {
                this.setState({
                    isLoading: false,
                    isReady: true,
                    errorMessage: "操作异常，请联系管理员！",
                });
            })
            .finally();
    };

    onFinish = async () => {
        await this.formRef.current.validateFields().then(() => {
            this.setState({
                btnEnable: false,
            });

            const params = this.getParamter(1);

            const bodyString = JSON.stringify(params);
            axios
                .post("/api/XinWangDaBackground/CreateBackgroundOrder", bodyString, {
                    headers: { "Content-Type": "application/json" },
                })
                .then((res) => {
                    const isSuccessValue = res.data.code == "200";
                    const resback = res.data.message;
                    let resdata = res.data.data;
                    let errorMessage = "";
                    if (!isSuccessValue) {
                        errorMessage = resback;
                    }
                    else {
                        if (resdata !== "" && resdata !== null) {
                            if (resdata.createOrderResult) {
                                errorMessage = "提交成功！" + resdata.errorMessage;
                            }
                            else {
                                if (resdata.canContinueLaunchOrder) {
                                    this.showModal(resdata.errorMessage)
                                }
                                else {
                                    errorMessage = resdata.errorMessage;
                                }
                            }
                        }
                        else {
                            errorMessage = "提交失败！";
                        }
                    }

                    if (errorMessage !== "") {
                        this.setState({ isLoading: false, isReady: true, errorMessage });
                    }
                })
                .catch((reason) => {
                    this.setState({
                        isLoading: false,
                        isReady: true,
                        errorMessage: "操作异常，请联系管理员！",
                    });
                })
                .finally();
        });
    };

    idTypeSelectedChanged = (value) => {
        if (value !== null && value !== "") {
            this.setState({
                idType: value,
            });
        }
    };

    getParamter = (parameterType) => {
        let applyId = this.state.applyId;
        let idCardNum = this.state.idCardNum;
        let reportId = this.state.reportId;
        let certifType = this.state.idType;
        let contractCompany = this.state.contractCompany;
        let companyOne = this.state.companyOne;
        let companyTwo = this.state.companyTwo;
        let companyThree = this.state.companyThree;
        let companyFour = this.state.companyFour;
        let companyFive = this.state.companyFive;
        const params = {
            applyId,
            certifType,
            idCardNum,
            contractCompany,
            reportId,
            parameterType,
            companyOne,
            companyTwo,
            companyThree,
            companyFour,
            companyFive,
        };

        return params;
    }

    contractCompanySelectedChanged = (value) => {
        if (value !== null && value !== "") {
            this.setState({
                contractCompany: value,
            });
        }
    };

    backpackageSelectedChanged = (value) => {
        if (value !== null && value !== "") {
            let backage = this.state.backgroundPackages.find(
                (item) => item.reportId == value
            );
            if (backage !== null) {
                this.state.contractCompanyValidDic
                    .filter((item) => item.key <= backage.searchCompanyNumber)
                    .map((item) => {
                        item.valid = true;
                    });

                this.state.contractCompanyValidDic
                    .filter((item) => item.key > backage.searchCompanyNumber)
                    .map((item) => {
                        item.valid = false;
                    });

                this.setState({
                    reportId: backage.reportId,
                });
            }
        }
    };

    showModal = (message) => {
        this.setState({
            modalOpenStatus: true,
            modalText: message,
            confirmLoading: false,
        });
    };

    handleCancel = () => {
        this.setState({
            modalOpenStatus: false,
            btnEnable: true,
        });
    };

    handleOk = () => {
        this.setState({
            confirmLoading: true,
        });
        const params = this.getParamter(0);
        const bodyString = JSON.stringify(params);
        console.log(bodyString)
        axios
            .post("/api/XinWangDaBackground/CreateBackgroundOrder", bodyString, {
                headers: { "Content-Type": "application/json" },
            })
            .then((res) => {
                const isSuccessValue = res.data.code == "200";
                const resback = res.data.message;
                let resdata = res.data.data;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = resback;
                }
                else {
                    if (resdata !== "" && resdata !== null) {
                        if (resdata.createOrderResult) {
                            errorMessage = "提交成功！" + resdata.errorMessage;
                        }
                        else {
                            errorMessage = resdata.errorMessage;
                        }
                    }
                    else {
                        errorMessage = "提交失败！";
                    }
                }
                this.setState({ isLoading: false, isReady: true, modalOpenStatus: false, confirmLoading: false, errorMessage });
            })
            .catch((reason) => {
                this.setState({
                    isLoading: false,
                    isReady: true,
                    modalOpenStatus: false,
                    confirmLoading: false,
                    errorMessage: "操作异常，请联系管理员！",
                });
            })
            .finally();
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (
                    <div style={{ textAlign: "center", padding: "32px" }}>
                        <span style={{ color: "red" }}>{this.state.errorMessage}</span>
                    </div>
                );
            } else {
                return (
                    <ConfigProvider>
                        <div className="xwd-wrap">
                            <div
                                className="header"
                                orientation="left"
                                style={{ fontSize: "18px" }}
                            >
                                发起背调
                            </div>
                            <Form
                                className="content"
                                name="dynamic_rule"
                                onFinish={this.onFinish}
                                ref={this.formRef}
                                initialValues={{
                                    idNumInput: this.state.idCardNum,
                                    idTypeSelect: this.state.idType,
                                }}
                            >
                                <Row gutter={24}>
                                    <Col span={11}>
                                        <Form.Item
                                            label="证件类型"
                                            name="idTypeSelect"
                                            required
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "请选择证件类型",
                                                },
                                            ]}
                                        >
                                            <Select
                                                allowClear
                                                placeholder="---请选择---"
                                                onChange={this.idTypeSelectedChanged}
                                            >
                                                {this.state.idTypes.map((item) => (
                                                    <Select.Option key={item.display} value={item.value}>
                                                        {item.display}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} offset={1}>
                                        <Form.Item
                                            label="证件号码"
                                            name="idNumInput"
                                            required
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "请输入证件号码",
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder="请输入"
                                                onChange={(e) => {
                                                    this.setState({
                                                        idCardNum: e.target.value,
                                                    });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={11}>
                                        <Form.Item
                                            label="合同公司"
                                            name="CompanyContrantSelect"
                                            required
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "请选择合同公司",
                                                },
                                            ]}
                                        >
                                            <Select
                                                allowClear
                                                placeholder="---请选择---"
                                                onChange={this.contractCompanySelectedChanged}
                                            >
                                                {this.state.contractCompanys.map((item) => (
                                                    <Select.Option key={item.display} value={item.value}>
                                                        {item.display}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} offset={1}>
                                        <Form.Item
                                            label="背调套餐"
                                            name="backpackageSelect"
                                            required
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "请选择背调套餐",
                                                },
                                            ]}
                                        >
                                            <Select
                                                allowClear
                                                placeholder="---请选择---"
                                                onChange={this.backpackageSelectedChanged}
                                            >
                                                {this.state.backgroundPackages.map((item) => (
                                                    <Select.Option
                                                        key={item.reportName}
                                                        value={item.reportId}
                                                    >
                                                        {item.reportName}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={11}>
                                        <Form.Item
                                            label="第一家公司名称"
                                            name="companyOneInput"
                                            rules={[
                                                {
                                                    required: this.state.contractCompanyValidDic.find(
                                                        (item) => item.key == 1
                                                    ).valid,
                                                    message: "请输入第一家公司名称",
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder="请输入"
                                                onChange={(e) => {
                                                    this.setState({
                                                        companyOne: e.target.value,
                                                    });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} offset={1}>
                                        <Form.Item
                                            label="第二家公司名称"
                                            name="companyTwoInput"
                                            rules={[
                                                {
                                                    required: this.state.contractCompanyValidDic.find(
                                                        (item) => item.key == 2
                                                    ).valid,
                                                    message: "请输入第二家公司名称",
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder="请输入"
                                                onChange={(e) => {
                                                    this.setState({
                                                        companyTwo: e.target.value,
                                                    });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={11}>
                                        <Form.Item
                                            label="第三家公司名称"
                                            name="companyThreeInput"
                                            rules={[
                                                {
                                                    required: this.state.contractCompanyValidDic.find(
                                                        (item) => item.key == 3
                                                    ).valid,
                                                    message: "请输入第三家公司名称",
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder="请输入"
                                                onChange={(e) => {
                                                    this.setState({
                                                        companyThree: e.target.value,
                                                    });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={11} offset={1}>
                                        <Form.Item
                                            label="第四家公司名称"
                                            name="companyFourInput"
                                            rules={[
                                                {
                                                    required: this.state.contractCompanyValidDic.find(
                                                        (item) => item.key == 4
                                                    ).valid,
                                                    message: "请输入第四家公司名称",
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder="请输入"
                                                onChange={(e) => {
                                                    this.setState({
                                                        companyFour: e.target.value,
                                                    });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={11}>
                                        <Form.Item
                                            label="第五家公司名称"
                                            name="companyFiveInput"
                                            rules={[
                                                {
                                                    required: this.state.contractCompanyValidDic.find(
                                                        (item) => item.key == 5
                                                    ).valid,
                                                    message: "请输入第五家公司名称",
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder="请输入"
                                                onChange={(e) => {
                                                    this.setState({
                                                        companyFive: e.target.value,
                                                    });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                            <div className="footer">
                                <Space>
                                    <Button onClick={() => closeModel("取消操作")}> 取消 </Button>
                                    <Button disabled={!this.state.btnEnable} onClick={this.onFinish} type="primary">
                                        提交
                                    </Button>
                                </Space>
                            </div>
                        </div>
                        <Modal
                            title="提示"
                            centered
                            visible={this.state.modalOpenStatus}
                            onOk={this.handleOk}
                            okText="确认再次发起"
                            cancelText="取消"
                            confirmLoading={this.state.confirmLoading}
                            onCancel={this.handleCancel}
                        >
                            <p>{this.state.modalText}</p>
                        </Modal>
                    </ConfigProvider>
                );
            }
        } else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}